import { FC } from "react";
import Container from "react-bootstrap/Container";
import { Navigate } from "react-router-dom";
import Button from "react-bootstrap/esm/Button";
import Alert from "react-bootstrap/esm/Alert";
import { NavigationScreen } from "app/component/screen/NavigationScreen";
import { reportRoute, reportVersionPrerequisitesRequestInformationEmailSendRoute } from "app/route/Routes";
import { useRouteParams } from "app/route/route";
import { RouteBreadcrumbs } from "app/route/RouteBreadcrumbs";
import { useSendPrerequisitesRequestInformationEmailMutation } from "app/api/graph/types";
import { reportVersionGraphId } from "app/api/graph/helpers";

export const SendPrerequisitesRequestInformationReportVersionEmailScreen: FC = () => {
    const { reportId, versionId } = useRouteParams(reportVersionPrerequisitesRequestInformationEmailSendRoute);

    const [send, { data, loading, error }] = useSendPrerequisitesRequestInformationEmailMutation({
        variables: { reportVersionId: reportVersionGraphId(versionId) },
    });

    return data?.sendPrerequisitesRequestInformationEmailReportVersion != null ? (
        <Navigate to={reportRoute.build({ reportId })} />
    ) : (
        <NavigationScreen>
            <Container>
                <RouteBreadcrumbs route={reportVersionPrerequisitesRequestInformationEmailSendRoute} />

                {error ? <Alert variant="danger">{error.message}</Alert> : null}

                <Alert variant="info">Do you really want to send the prerequisites request information email?</Alert>

                <Button disabled={loading} onClick={() => send()}>
                    Send
                </Button>
            </Container>
        </NavigationScreen>
    );
};
